import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useUpdateBranch } from "../../../hooks/query/useUpdateBranch";

type BranchTagProps = {
    branch: {
        id: number;
        name: string;
        address: string;
        phone: string;
    };
    onEdit?: (branchId: number) => void;
    onDelete?: (branchId: number) => void;
};

const BORDER_CLASSES = [
    "border-l-red-500",
    "border-l-blue-500",
    "border-l-green-500",
    "border-l-yellow-500",
    "border-l-purple-500",
    "border-l-pink-500",
];

function BranchTag(props: BranchTagProps) {
    const { branch, onEdit, onDelete } = props;
    const { id, name, address, phone } = branch;
    const [type, setType] = useState<string>("");
    const [editData, setEditData] = useState({
        name,
        address,
        phone,
    });

    const borderClass = BORDER_CLASSES[id % BORDER_CLASSES.length];


    const handleEdit = () => {
        setType("edit");
        onEdit?.(id);
    }

    const handleCancel = () => {
        setType("");
    }


    useEffect(() => {
        if (type === "edit") {
            setEditData({ name, address, phone });
        }
    }, [type, name, address, phone]);

    const { mutate: updateBranch } = useUpdateBranch();

    const handleSave = () => {
        updateBranch(
            {
                id,
                data: {
                    name: editData.name,
                    address: editData.address,
                    phone: editData.phone,
                },
            },
            {
                onSuccess: () => {
                    toast.success("Cập nhật chi nhánh thành công!");
                    setType("");
                },
                onError: () => {
                    toast.error("Cập nhật chi nhánh thất bại!");
                },
            }
        );
    };

    return (
        <div
            className={`border-l-[18px] border-t-[1px] border-r-[1px] border-b-[1px] rounded-[16px] ${borderClass} p-3 rounded text-white flex justify-between gap-4`}
        >
            {/* Thông tin */}
            {type !== 'edit' ? (<div>
                <h3 className="text-[16px] font-bold">{name}</h3>
                <p className="my-[10px]">
                    <span>Địa chỉ:&nbsp;</span>{address}
                </p>
                <p>
                    <span>Số điện thoại:&nbsp;</span>{phone}
                </p>
            </div>) : (
                <div>
                    <input
                        className="text-black rounded-[4px] outline-none w-[300px] py-[4px] px-[8px]"
                        value={editData.name}
                        onChange={e =>
                            setEditData(prev => ({ ...prev, name: e.target.value }))
                        }
                    />
                    <p className="my-[10px]">
                        <span>Địa chỉ:&nbsp;</span>
                        <input
                            className="text-black rounded-[4px] outline-none w-[300px] py-[4px] px-[8px]"
                            value={editData.address}
                            onChange={e =>
                                setEditData(prev => ({ ...prev, address: e.target.value }))
                            }
                        />
                    </p>
                    <p>
                        <span>Số điện thoại:&nbsp;</span>
                        <input
                            className="text-black rounded-[4px] outline-none w-[300px] py-[4px] px-[8px]"
                            value={editData.phone}
                            onChange={e =>
                                setEditData(prev => ({ ...prev, phone: e.target.value }))
                            }
                        />
                    </p>
                </div>
            )
            }
            {/* Actions */}
            <div className="flex flex-col gap-2">
                {type === "edit" ? (<button
                    className="px-3 py-1 text-sm rounded bg-blue-500 text-white hover:bg-blue-600"
                    onClick={handleSave}
                >
                    Lưu
                </button>) :
                    (<button
                        className="px-3 py-1 text-sm rounded bg-blue-500 text-white hover:bg-blue-600"
                        onClick={handleEdit}
                    >
                        Chỉnh sửa
                    </button>)}
                {type === "edit" && <button
                    className="min-w-[85px] min-h-[30px] px-3 py-1 text-sm rounded bg-gray-500 text-white hover:bg-gray-600"
                    onClick={handleCancel}
                >
                    Hủy
                </button>}
                {type !== "edit" && <button
                    className="px-3 py-1 text-sm rounded bg-red-500 text-white hover:bg-red-600"
                    onClick={() => onDelete?.(id)}
                >
                    Xóa
                </button>}
            </div>
        </div>
    );
}

export default BranchTag;
